import styled from 'styled-components'

export const FooterContainer = styled.footer`
    background-color: #101522;

`

export const FooterWrap = styled.div`
    padding: 48px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1100px;
    margin: 0 auto;
    font-size: 12px;
`